(() => {
  const root = document.querySelector('.da-house--monumental');
  if (!root) return;

  const choice = new URLSearchParams(window.location.search).get('da_motion');
  const motion = choice === 'a' || choice === 'b' || choice === 'hybrid' ? choice : 'static';
  root.dataset.daMotion = motion;

  const triptychChoice = new URLSearchParams(window.location.search).get('da_triptych');
  root.dataset.daTriptych = triptychChoice === 'alternate' ? 'alternate' : 'primary';

  const directionChoice = new URLSearchParams(window.location.search).get('da_direction');
  root.dataset.daDirection = directionChoice === 'a' || directionChoice === 'b' || directionChoice === 'c' ? directionChoice : 'current';

  if (root.dataset.daDirection === 'a' || root.dataset.daDirection === 'c') {
    const imageSelectors = root.dataset.daDirection === 'a'
      ? '[data-da-directions="a-c"] img[data-src],[data-da-directions="a"][data-src]'
      : '[data-da-directions="a-c"] img[data-src]';
    root.querySelectorAll(imageSelectors).forEach((image) => {
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
    });
  }

  if (motion === 'static' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const targets = [
    '.da-declaration .da-shell',
    '.da-doctrine .da-shell',
    '.da-procession',
    '.da-transformation__head',
    '.da-triptych figure',
    '.da-embodied>div',
    '.da-dual .da-shell',
    '.da-opus .da-shell',
    '.da-commerce .da-shell',
    '.da-maxim'
  ].flatMap((selector) => Array.from(root.querySelectorAll(selector)));

  if (motion === 'hybrid') {
    targets.forEach((target) => {
      const processional = target.matches('.da-refinement-images,.da-integration-image,.da-collection-entry__head,.da-portals');
      target.dataset.daMotionRole = processional ? 'processional' : 'ceremonial';
    });
  }

  targets.forEach((target) => target.setAttribute('data-da-reveal', ''));
  root.classList.add('da-motion-ready');

  if (!('IntersectionObserver' in window)) {
    targets.forEach((target) => target.classList.add('da-revealed'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('da-revealed');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

  targets.forEach((target) => observer.observe(target));
})();
